// extracted by mini-css-extract-plugin
export var current = "current-ju3";
export var paginationWrapper = "paginationWrapper-8QQ";